import { COSTCO_TRAVEL, KEY_PID, KEY_SKU } from "../../../Analytics/constants.js";
import { containerStyles, containerStylesSponsoredBordered, withSponsoredStyles, withSponsoredStylesBordered } from "./styles.js";
function getSponsoredBadgeStyle(variant) {
  switch (variant) {
    case "bordered":
      return withSponsoredStylesBordered;
    case "default":
    default:
      return withSponsoredStyles;
  }
}
function getTileContainerStyle({
  sx,
  isSponsored,
  sponsoredDisplayVariant
}) {
  const defaultStyles = { ...containerStyles, ...sx || {} };
  if (!isSponsored) {
    return defaultStyles;
  }
  if (sponsoredDisplayVariant === "bordered") {
    return {
      ...defaultStyles,
      ...containerStylesSponsoredBordered
    };
  }
  return defaultStyles;
}
function checkIsAd({
  isSponsored,
  criteoDataSourceAttr
}) {
  return Boolean(isSponsored) || Boolean(criteoDataSourceAttr);
}
function getDataSource(isAd) {
  return isAd ? "sponsored" : "native";
}
function getDoNotTrack({
  dataPrivate,
  isFsaEligible,
  isChdiEligible,
  enableAnalytics
}) {
  return Boolean(
    dataPrivate || isFsaEligible || isChdiEligible || !enableAnalytics
  );
}
function getAnalyticsComponent(productInfoData, isCostcoTravel) {
  if (isCostcoTravel) {
    return {
      trackedData: [COSTCO_TRAVEL, productInfoData.productName]
    };
  }
  return void 0;
}
function getAnalyticsTrackedData(productInfoData, isCostcoTravel) {
  if (isCostcoTravel) {
    return void 0;
  }
  return [
    { key: KEY_PID, value: productInfoData == null ? void 0 : productInfoData.partNumber },
    { key: KEY_SKU, value: productInfoData == null ? void 0 : productInfoData.itemNumber }
  ];
}
export {
  checkIsAd,
  getAnalyticsComponent,
  getAnalyticsTrackedData,
  getDataSource,
  getDoNotTrack,
  getSponsoredBadgeStyle,
  getTileContainerStyle
};
